"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  sk: {
    reactMuiTables: {
      selected: 'vybrané',
      filterhide: 'Skryť filter',
      filtershow: 'Zobraziť filter',
      refresh: 'Obnoviť',
      filter: {
        actions: {
          search: 'Vyhľadať',
          resetFilter: 'Resetovať filter',
          addCondition: 'Pridať podmienku'
        }
      },
      standardOperators: {
        equals: 'rovné',
        contains: 'obsahuje',
        between: {
          label: 'medzi',
          from: 'od',
          to: 'do'
        },
        oneOf: 'jeden z'
      },
      labelRowsPerPage: 'Riadkov na stránku:'
    }
  }
};
var _default = messages;
exports.default = _default;